import { Button, Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { ICustomer, ICustomerQuery, IUpdateCustomer } from "../../models/Sale";
import { useUpdateCustomer } from "../../query/SaleQuery";
import { notify } from "../../utils/toast";

interface ModalEditCustomerProps {
  open: boolean;
  record?: ICustomer | null;
  onCancel: () => void;
  onSuccess: () => void;
  params: ICustomerQuery;
}

const ModalEditCustomer = ({
  open,
  record,
  onCancel,
  onSuccess,
  params,
}: ModalEditCustomerProps) => {
  const [form] = Form.useForm();
  const updateCustomer = useUpdateCustomer();
  useEffect(() => {
    if (record && open) {
      form.setFieldsValue({
        code: record.code,
        name: record.name,
        address: record.address,
        taxCode: record.taxCode,
      });
    }
  }, [record, open, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values: IUpdateCustomer) => {
        try {
          if (record) {
            await updateCustomer.mutateAsync({
              id: record.id,
              data: values,
              query: params,
            });
            notify.success("Cập nhật khách hàng thành công");
            onSuccess();
          }
        } catch (error) {
          notify.error("Cập nhật khách hàng thất bại");
        }
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Chỉnh sửa khách hàng"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleOk}
          loading={updateCustomer.isPending}
        >
          Cập nhật
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" style={{ marginTop: "20px" }}>
        <Form.Item
          label="Mã khách hàng"
          name="code"
          rules={[{ required: true, message: "Vui lòng nhập mã khách hàng" }]}
        >
          <Input placeholder="Nhập mã khách hàng" />
        </Form.Item>

        <Form.Item
          label="Tên khách hàng"
          name="name"
          rules={[{ required: true, message: "Vui lòng nhập tên khách hàng" }]}
        >
          <Input placeholder="Nhập tên khách hàng" />
        </Form.Item>

        <Form.Item
          label="Địa chỉ"
          name="address"
          rules={[{ required: true, message: "Vui lòng nhập địa chỉ" }]}
        >
          <Input placeholder="Nhập địa chỉ" />
        </Form.Item>

        <Form.Item
          label="Mã số thuế"
          name="taxCode"
          rules={[{ required: true, message: "Vui lòng nhập mã số thuế" }]}
        >
          <Input placeholder="Nhập mã số thuế" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditCustomer;
